import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Redirect to hidden login page, preserving intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
